import OfferteFormPro from "@/components/feature/OfferteFormPro";

export default function OfferteForm() {
  return (
    <OfferteFormPro
      formId="offerte-glas-vervangen"
      formUrl="https://formspree.io/f/xgoqdank"
      defaultSubject="Glas vervangen HR++"
    />
  );
}